/* global */
import React from 'react'
import {Modal} from 'react-bootstrap'

export default React.createClass({
    getInitialState: function () {

      return {
        card: {
          upSellType: '',
        }
      }
    },
  onClickImg: function (type) {
    let destination

    let addressId = this.props.addressId
    if(this.props.newAddress) {
      addressId = this.props.newAddress
      console.log("ADDRESS ID", addressId)
    }

    switch (type) {
      case 'Lawn Mowing':
        destination = '/showOrderNewTask/' + addressId + '/MOWLAWN/propertyDetails'
        window.location.assign(window.location.origin + destination)
        break
      case 'Fertilization':
      let newCard = this.state.card
      newCard.upSellType = 'FERTILIZATION_TASK'
      this.setState({card: newCard})
      {this.props.hide()}
      {this.props.openUpsellModal(this.state.card, addressId)}
        break
      case 'Spring Cleanup':
      newCard = this.state.card
      newCard.upSellType = 'SPRING_SEASONAL_TASK'
      this.setState({card: newCard})
      {this.props.hide()}
      {this.props.openUpsellModal(this.state.card, addressId)}
        break
      case 'Fall Cleanup':
      newCard = this.state.card
      newCard.upSellType = 'FALL_SEASONAL_TASK'
      this.setState({card: newCard})
      {this.props.hide()}
      {this.props.openUpsellModal(this.state.card, addressId)}
        break
      case 'Aeration':
      newCard = this.state.card
      newCard.upSellType = 'AERATION_TASK'
      this.setState({card: newCard})
      {this.props.hide()}
      {this.props.openUpsellModal(this.state.card, addressId)}
        break
      case 'Custom':
      newCard = this.state.card
      this.setState({card: newCard})
      {this.props.hide()}
      {this.props.openCustom(this.state.card, addressId)}
        break
      default:
        break
    }
  },
  render: function () {
    let seasonalBox

    function getSeason(component){
      var today = new Date()
      var month = today.getMonth()+1
      if(month <= 6){
        seasonalBox = <div><div className={'task-type center no-text'}>
                        <div id='springCleanupImg' className={'springcleanup-icon'} onClick={() => component.onClickImg('Spring Cleanup')}/>
                      </div><br />
                      <p className='springcleanup-color'><strong>Spring Cleanup</strong></p></div>
      } else {
        seasonalBox = <div><div className={'task-type center no-text'}>
                        <div id='fallCleanupImg' className={'fallcleanup-icon'} onClick={() => component.onClickImg('Fall Cleanup')}/>
                      </div><br />
                      <p className='fallcleanup-color'><strong>Fall Cleanup</strong></p></div>
      }
    }

    getSeason(this);

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='new-task-modal'>
          <Modal.Header closeButton>
            <h2 className='text-center pull-down-xs-3'>{this.props.modalHeader}</h2>
            <p className='text-center pull-down-xs-2' style={{padding: '0 10px 0 10px', fontSize: '24px'}}>{this.props.modalSubHeader}</p>
            <br />
            <form style={{width:'70%', margin:'auto'}}>
              <div className='row pull-down-sm-2'>
                <div className='col-xs-6 text-center link-cursor'>
                  <div className={'task-type center no-text'}>
                    <div id='lawnMowingImg' className={'lawnmowing-icon'} onClick={() => this.onClickImg('Lawn Mowing')}/>
                  </div><br />
                  <p className='lawnmowing-color'><strong>Lawn Mowing</strong></p>
                </div>
                <div className='col-xs-6 text-center link-cursor'>
                  <div className={'task-type center no-text'}>
                    <div id='aeration' className={'aeration-icon'} onClick={() => this.onClickImg('Aeration')}/>
                  </div><br />
                  <p className='aeration-color'><strong>Aeration</strong></p>
                </div>
              </div>
              <br />
              <div className='row pull-down-sm-2'>
                <div className='col-xs-6 text-center link-cursor'>
                  <div className={'task-type center no-text'}>
                    <div id='fertilization' className={'fertilization-icon'} onClick={() => this.onClickImg('Fertilization')}/>
                  </div><br />
                  <p className='fertilization-color'><strong>Fertilization</strong></p>
                </div>
                <div className='col-xs-6 text-center link-cursor'>
                  {seasonalBox}
                </div>
              </div>
              <br />
              <div className='row pull-down-sm-2'>
                {/*<div className='col-xs-6 text-center'>
                  <img type='button' onClick={() => this.onClickImg('Custom')} src={custom} alt='Responsive' /><br />
                  <p className='custom-color'><strong>Custom Task</strong></p>
                </div> */}
              </div>
            </form>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/new-task-modal.jsx